//--- React
import { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
//--- Ant Design
import { Card, Col, Row, Tabs } from "antd";
import MARKET_PULSE_ICON from "assets/images/icons/MarketPulse.svg";

//--- Project
import "./styles.css";
import { useRequiredAccess } from "hooks/useRequiredAccess";
import { ORG_TYPES } from "components/Common/Constants";
import MarketPulseOverview from "./Overview";
import MarketPulseFeedback from "./FeedbackAnalytics";
import { useQuery } from "@tanstack/react-query";
import { getCompanies } from "apis/competitorPulseApis";
import MarketPulseComparison from "./Comparison";

const MarketPulse = () => {
  const location = useLocation();
  const checkAccess = useRequiredAccess([], [ORG_TYPES.ADMINISTRATOR]);
  const [selectedCompany, setSelectedCompany] = useState(null);
  const [selectedSentiment, setSelectedSentiment] = useState(null);

  const [selectedTab, setSelectedTab] = useState(
    location?.state?.tabName || "overview"
  );

  useEffect(() => {
    checkAccess();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  const {
    data: companiesList,
    isLoading: companyDataLoading,
  } = useQuery({
    queryKey: ["companyList"],
    queryFn: () => getCompanies(),
    keepPreviousData: true,
    refetchOnWindowFocus: false,
  });
  

  const onChangeTab = (key, company = null, sentiment = null) => {
    setSelectedTab(key);
    if (company) {
      setSelectedCompany(company);
    }
      setSelectedSentiment(sentiment || null);
  };
  
  const items = [
    {
      key: "overview",
      label: "Overview",
      children: (
        <MarketPulseOverview
          onChangeTab={onChangeTab}
        />
      ),
    },
    {
      key: "detailed-insights",
      label: "Detailed Insights",
      children: (
        <MarketPulseFeedback
          selectedCompany={selectedCompany}
          selectedSentiment={selectedSentiment}
          companiesList={companiesList}
          companyDataLoading={companyDataLoading}
        />
      ),
    },
    {
      key: "comparison",
      label: "Comparison",
      children: (
        <MarketPulseComparison
        onChangeTab={onChangeTab}
        companiesList={companiesList}

        />
      ),
    },
    // {
    //   key: "compare",
    //   label: "Compare",
    //   children: <></>,
    // },
  ];

  

  return (
    <>
    
    <Row justify={"center"} className="competitor-pulse-page h100vh">     
      <Col xs={24} sm={24} md={24} lg={23} xl={22}>
      <Card bordered={false} className="competitor-pulse-page marketpulse-header-card">
        <Row
          gutter={[16, 16]}
          justify={"space-around"}
          align={"middle"}
          className="mt05"
        >
          <Col xs={24} md={18} lg={14}>
            <div className="title">Market Pulse</div>
            <div className="title-content">
            Hear what EV customers are saying across the web distilled by AI.
</div>
          </Col>
          <Col xs={0} md={6} lg={10}>
            <img
              src={MARKET_PULSE_ICON}
              alt="market"
              height={68}
              className="float-right"
            />
          </Col>
        </Row>
      </Card>
        <Tabs className="marketpulse-tab"  activeKey={selectedTab} items={items} onChange={onChangeTab} />
      
      </Col>
    </Row>
    </>
  );
};

export default MarketPulse;
